import { PropsWithChildren } from "react";
import classNames from "classnames";

export type ButtonVariant = "primary" | "secondary" | "link";

export interface ButtonProps
  extends PropsWithChildren,
    React.HTMLProps<HTMLButtonElement> {
  disabled?: boolean;
  variant?: ButtonVariant;
  className?: string;
}

const Button = ({
  variant,
  disabled = false,
  className,
  children,
  type,
  ...rest
}: ButtonProps) => {
  return (
    <button
      className={classNames(
        "button",
        variant && `button--${variant}`,
        className && className,
      )}
      disabled={disabled ?? false}
      {...rest}
    >
      {children}
    </button>
  );
};

export { Button };
